import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { Project } from 'records/Project';
import { Role, RoleMap, Roles } from 'records/Role';
import { getRoles, setRole } from 'services/roleService';
import permsCheck from 'utils/permsCheck';

export interface RoleActions {
  getRoles: (actionParams: AppStateActionParams) => Promise<AppState>;
  setRole: (
    actionParams: AppStateActionParams,
    userId: string,
    role: Roles
  ) => Promise<AppState>;
}

const roleActions = {
  getRoles: async ({ state }: AppStateActionParams): Promise<AppState> => {
    const { selectedProject, userLicense } = state();

    const roles = await getRoles(selectedProject, userLicense.package);

    const roleByUserKey = roles.reduce(
      (acc: RoleMap, role: Role): RoleMap => acc.set(role.userid, role),
      Immutable.Map<string, Role>()
    );

    return state().set('roles', roleByUserKey);
  },

  setRole: permsCheck(
    ['managePeople'],
    async (
      { state }: AppStateActionParams,
      userId: string,
      role: Roles
    ): Promise<AppState> => {
      const { selectedProject, projects } = state();
      const { permissions }: Project = projects.get(
        selectedProject,
        new Project()
      );

      if (permissions.managePeople) {
        const newRole = await setRole(selectedProject, userId, role);
        return state().setIn(['roles', userId], newRole);
      }

      console.log(
        'Unable to set role: User does not have managePeople permission'
      );
      return state();
    }
  ),
};

export default roleActions;
